module.exports = __webpack_public_path__ + "img/payment-cancel.e183ebfc.jpg";